import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { InsightService } from '../insight-new/insight.service';
import { Dependencies } from '../store';
import { PayloadAction } from '../store.model';

import {
    ActionType,
    Reload,
    ReloadResult,
    reloadResult,
} from './coaching-card-rep.action';

const reload = (
    action: ActionsObservable<PayloadAction<ActionType, Reload>>,
    _state: StateObservable<any>,
    deps: Dependencies,
): Observable<PayloadAction<ActionType, ReloadResult>> =>
    action.pipe(
        ofType(ActionType.COACHING_CARD_REP__ROOT__RELOAD),
        switchMap((act) => {
            const service = deps.injector?.get<InsightService>(InsightService);

            return of(null).pipe(
                service.retrieveRepCard(() => ({
                    userId: act.payload.userId,
                    periodTypeId: act.payload.periodTypeId,
                })),
                map((ret) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            card: ret,
                        },
                        act.storePath,
                    );
                }),
                catchError(() =>
                    of(reloadResult({ ...act.payload }, act.storePath)),
                ),
            );
        }),
    );

export const coachingCardRepEpics = [reload];
